import { Navigate, Outlet } from 'react-router-dom';
import { getReturnUrl } from './utilities';
import useQueryString from './hooks/useQuery';
import { useAuth } from './AuthProvider';

export default function PublicRoute() {
  const queryParams = useQueryString();
  const { isLoggedIn } = useAuth();
  if (isLoggedIn) {
    return <Navigate to={getReturnUrl(queryParams)} replace />;
  }

  return <Outlet />;
}
